import { clamp } from '../../render/utils/math';

export const sharpen = {
  name: 'sharpen',
  shader: `precision mediump float;
varying vec2 v_texCoord;
uniform sampler2D u_image;
uniform vec2 u_resolution;
uniform float u_strength;

void main() {
    vec2 pixel_size = 1.0 / u_resolution;

    vec4 center_color = texture2D(u_image, v_texCoord);

    vec3 s_top    = texture2D(u_image, clamp(v_texCoord + vec2(0.0, pixel_size.y), 0.0, 1.0)).rgb;
    vec3 s_bottom = texture2D(u_image, clamp(v_texCoord - vec2(0.0, pixel_size.y), 0.0, 1.0)).rgb;
    vec3 s_left   = texture2D(u_image, clamp(v_texCoord - vec2(pixel_size.x, 0.0), 0.0, 1.0)).rgb;
    vec3 s_right  = texture2D(u_image, clamp(v_texCoord + vec2(pixel_size.x, 0.0), 0.0, 1.0)).rgb;

    vec3 sum = center_color.rgb 
               + (center_color.rgb - s_top) * u_strength
               + (center_color.rgb - s_bottom) * u_strength
               + (center_color.rgb - s_left) * u_strength
               + (center_color.rgb - s_right) * u_strength;

    vec3 final_color = clamp(sum, 0.0, 1.0);

    gl_FragColor = vec4(final_color, center_color.a);
}`,
  uniforms: [
    {
      name: 'u_strength',
      normalize: (val) => clamp(val / 100, 0, 1),
    },
  ],
};
